import { Button, ButtonProps } from '@nextui-org/react';
import React from 'react';

const ButtonSubmit: React.FC<ButtonProps> = ({ children, fullWidth = true, ...props }) => {
  return (
    <Button
      size='md'
      radius='sm'
      fullWidth={fullWidth}
      className='bg-bg-brand-solid text-white'
      {...props}
    >
      {children}
    </Button>
  );
};

export default ButtonSubmit;
